import React from 'react';
import styled from 'styled-components';

interface TKFIconProps {
  size?: number;
  className?: string;
}

const SvgContainer = styled.svg<{ size: number }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  display: block;
`;

const TKFIconWhite: React.FC<TKFIconProps> = ({ 
  size = 40, 
  className 
}) => {
  return (
    <SvgContainer 
      size={size}
      className={className}
      viewBox="0 0 1200 1200" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <image
        href="/TKF-Icon.svg"
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid meet"
      />
    </SvgContainer>
  );
};

export default TKFIconWhite;